/**
 * The read of the company's name correction (`GET /api/customer/ein-corrections`), kept apart from
 * the write calls in `api.ts`: the customer sidebar imports it on every page, and the upload
 * helpers `api.ts` brings in belong to the page's chunk, not the shell's.
 */
import { productData } from '@/lib/api/product-data-client'

import type { EinCorrectionLanding } from './types'

export const EIN_CORRECTION_BASE = '/api/customer/ein-corrections'

/** Cache key of the landing read, scoped to the company. The page and the sidebar share it. */
export const EIN_CORRECTION_CACHE_KEY = 'ein-correction'

export function fetchEinCorrection(companyId: string): Promise<EinCorrectionLanding> {
  return productData<EinCorrectionLanding>(`${EIN_CORRECTION_BASE}?companyId=${encodeURIComponent(companyId)}`)
}

/**
 * The company has a request the customer may want to come back to: one in progress or finished.
 * A cancelled request is nothing to come back to.
 */
export function hasEinCorrectionToReturnTo(landing: EinCorrectionLanding | null | undefined): boolean {
  const correction = landing?.correction
  return Boolean(correction) && correction?.status !== 'cancelled' && correction?.nextStep !== 'cancelled'
}
